"use client";
import useProductImageModal from "../../portal/hooks/useProductImageModal";
import Slider from "../../common/components/Slider";
import Image from "next/image";
const ProductImageGallery = ({ product }) => {
  const { media, texts } = product;
  const { ProductImageModal, showImage } = useProductImageModal(texts?.title);

  const handleImageClick = (mediaIndex) => {
    showImage(media[mediaIndex]);
  };
  return (
    <>
      {ProductImageModal}
      <Slider
        navigation={true}
        autoPlay={false}
        displayThumbnails={true}
        onClick={handleImageClick}
      >
        {media?.map((m) => (
          <div
            className="position-relative w-100"
            key={m._id}
            style={{ aspectRatio: "1/1" }}
          >
            <Image
              src={m.file.url}
              alt={m.texts?.title || m._id}
              fill
              sizes="(max-width: 840px) 100vw, 50vw"
              style={{ objectFit: "cover", objectPosition: "center" }}
            />
          </div>
        ))}
      </Slider>
    </>
  );
};

export default ProductImageGallery;
